import styled from 'styled-components';

// ── Estágio 2: duas seções lado a lado ──────────────────────────────────────
// "Confirmar o código" e "escolher a senha nova" são dois contextos distintos
// que só por acaso são gravados no mesmo request (não existe endpoint para
// validar o código isoladamente — 0098 §6). Empilhados numa coluna só, viram
// um formulário alto de 5 campos onde nada explica por que o código e a senha
// estão juntos. Lado a lado, cada coluna carrega suas próprias instruções.
export const StageGrid = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 24px;
   align-items: start;

   @media (max-width: 720px) {
      grid-template-columns: 1fr;
      gap: 20px;
   }
`;

export const StageSection = styled.section`
   display: grid;
   gap: 12px;
   align-content: start;
   min-width: 0;

   /* Separador de contexto entre as colunas — vira horizontal quando
      empilham. */
   & + & {
      padding-left: 24px;
      border-left: 1px solid ${({ theme }) => theme.colors.borderLight};

      @media (max-width: 720px) {
         padding-left: 0;
         padding-top: 20px;
         border-left: none;
         border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
      }
   }
`;

export const SectionHead = styled.h2`
   margin: 0;
   font-size: 13px;
   font-weight: 700;
   letter-spacing: 0.04em;
   text-transform: uppercase;
   color: ${({ theme }) => theme.colors.textMuted};
`;

// Chip do alvo: mantém o e-mail informado visível no estágio 2, com escape
// para corrigir sem perder o contexto do formulário.
export const TargetChip = styled.div`
   display: grid;
   gap: 4px;

   padding: 10px 12px;

   font-size: 13px;
   line-height: 1.45;
   color: ${({ theme }) => theme.colors.textPrimary};
   word-break: break-word;

   background: ${({ theme }) => theme.colors.surfaceMuted};
   border: 1px solid ${({ theme }) => theme.colors.borderLight};
   border-radius: 10px;
`;

export const StageNote = styled.p`
   margin: 0;
   font-size: 12px;
   line-height: 1.5;
   color: ${({ theme, $expired }) =>
      $expired ? theme.colors.danger : theme.colors.textMuted};
`;

// Rodapé do formulário: ação de escrita na ponta direita (FC7 §G.5).
export const FormFoot = styled.div`
   display: flex;
   flex-wrap: wrap;
   gap: 12px;
   align-items: center;
   justify-content: space-between;

   margin-top: 20px;
   padding-top: 16px;
   border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
`;
